module.exports = __webpack_public_path__ + "static/media/gb7.8737e377.png";